// Centralized API configuration - reads from .env with fallbacks
// To change URLs in production, update .env file (no rebuild needed)

// Auth Service (backend_auth)
export const API_BASE_URL = 
  process.env.REACT_APP_API_BASE_URL || 'https://auth.arcattend.com';

// Main Backend Service (backend)
export const BACKEND_API_BASE_URL = 
  process.env.REACT_APP_BACKEND_API_BASE_URL || 'http://localhost:4000';

// Calculations/Analytics Service (backend_calculations)
export const CALCULATIONS_API_BASE_URL = 
  process.env.REACT_APP_CALCULATIONS_API_BASE_URL || 'http://localhost:4002';

// Daily Reporting Service (backend_daily_reporting)
export const DAILY_REPORTING_API_BASE_URL = 
  process.env.REACT_APP_DAILY_REPORTING_API_BASE_URL || 'http://localhost:4003';

// Feature Flags
// Enable/disable alpha credentials gate (set REACT_APP_REQUIRE_ALPHA_CREDENTIALS=true/false in .env)
export const REQUIRE_ALPHA_CREDENTIALS = 
  process.env.REACT_APP_REQUIRE_ALPHA_CREDENTIALS === 'true';

// Maintenance Mode - when enabled, entire app redirects to maintenance page
export const MAINTENANCE_MODE = 
  process.env.REACT_APP_MAINTENANCE_MODE === 'true';
